import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../../../../_services/constant";

export default function CustomCategoryBanner(props) {
  return (
    <>
      <div className="container toppadhead">
        <div className="row toppad3 mtoppad2">
          <div className="col-sm-12">
            <div>
              <img
                src={`${API_BASE_URL}BranchBannerCategory/${localStorage.getItem(
                  "jwl_category_banner_path"
                )}`}
                className=" d-none d-lg-block d-md-block imgcurve custom-banner custom-banner"
              />
              <img
                src={`${API_BASE_URL}BranchBannerCategory/${localStorage.getItem(
                  "jwl_category_banner_path"
                )}`}
                className=" d-none d-lg-none d-md-none d-block imgcurve custom-banner custom-banner"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="clr"></div>
    </>
  );
}
